<template>
    <div>
        <!-- 确认订舱 -->
        <vForm
            class="clearfix"
            v-if="type === 'confirmBookingSpace'"
            v-model="formData"
            labelWidth="150"
            style="text-align: left;"
            ref="dataForm"
        >
            <!-- <vFormItem v-show="false" prop="price" class="width-75per" :label="$t('fbb.headlogistics.price', { defaultValue: `运费报价` }) + '(USD)'" :rules="required">
                <vInputNumber min="0" v-model="formData.price"></vInputNumber>
            </vFormItem> -->
            <vFormItem prop="china_estimate_cost" class="width-75per" :label="$t('fbb.headlogistics.expect_china_cost', { defaultValue: `中国段预估费用` })" :rules="required">
                <vInputNumber min="0" v-model="formData.china_estimate_cost"></vInputNumber>
            </vFormItem>
            <vFormItem prop="ocean_freight_estimate" class="width-75per" :label="$t('fbb.headlogistics.expect_sea_delivery_cost', { defaultValue: `预估海运费` })" :rules="required">
                <vInputNumber min="0" v-model="formData.ocean_freight_estimate"></vInputNumber>
            </vFormItem>
            <vFormItem prop="destination_estimate_cost" class="width-75per" :label="$t('fbb.headlogistics.destination_cost', { defaultValue: `目的国费用` })" :rules="required">
                <vInputNumber min="0" v-model="formData.destination_estimate_cost"></vInputNumber>
            </vFormItem>
            <vFormItem prop="tariff_estimate" class="width-75per" :label="$t('fbb.headlogistics.tariff', { defaultValue: `关税` })" :rules="required">
                <vInputNumber min="0" v-model="formData.tariff_estimate"></vInputNumber>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' })" class="width-75per" prop="forwarder_name" :rules="required">
                <vSelect v-model="formData.forwarder_id" filterable @on-change="changeForward">
                    <vOption v-for="item in companyList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                </vSelect>
            </vFormItem>
            <!-- 根据货代公司是否为运去哪（1000370）判断货代单号是否必填 -->
            <vFormItem :label="$t('fbb.headlogistics.forward_order_id', { defaultValue: '货代单号' })" class="width-75per" prop="order_id" :rules="formData.forwarder_id == 1000370 ? required : null">
                <vInput v-model="formData.order_id"></vInput>
            </vFormItem>
            <vFormItem :label="$t('bi.paymentterm.payment_term', { defaultValue: '付款周期' })" class="width-75per" prop="agent_payment_term">
                <vInput v-model="formData.agent_payment_term" :disabled="true"></vInput>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.other_cost', { defaultValue: '其他费用' })" class="width-75per" prop="other_estimate_cost">
                <vInput v-model="formData.other_estimate_cost"></vInput>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.forwarder_warehouse', { defaultValue: '中转仓' })" v-if="logisticsType === 'transfer'" class="width-75per">
                <vSelect v-model="formData.forwarder_warehouse_id" filterable @on-change="changeWareHouse">
                    <vOption v-for="item in getFilterDisabledWarehouse" :key="item" :value="item.value">{{item.label}}</vOption>
                </vSelect>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.transport_type', { defaultValue: '发运方式' })" class="width-75per" prop="transport_type" :rules="required">
                <vSelect v-model="formData.transport_type" filterable>
                    <vOption v-for="item in transportList" :key="item" :value="item.value">{{item.label}}</vOption>
                </vSelect>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.order_src', { defaultValue: '订舱单' })" class="width-75per">
                <div class="upload" v-if="formData.order_src">
                    <div class="upload-item">
                        <div class="filename">{{formData.order_src}}</div>
                        <div><Icon class="close" size="13" type="md-close" @click="clearUpload" /></div>
                    </div>
                </div>
                <vButton v-else theme="success" @click="importFile">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
            </vFormItem>
        </vForm>
        <!-- 已订舱 -->
        <vForm class="clearfix" ref="dataForm" v-else-if="type === 'hasConfirmBookingSpace'" v-model="formData" labelWidth="150" style="text-align: left;">
            <vFormItem class="width-75per" :label="$t('fbb.headlogistics.voyage_name', { defaultValue: '船名航次' })" prop="voyage_name"  :rules="required">
                <vInput v-model="formData.voyage_name"></vInput>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' })" class="width-75per" prop="purpose_port_id" :rules="required">
                <vSelect v-model="formData.purpose_port_id" @on-change="changePort" filterable>
                    <vOption v-for="item in getSystemPortList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                </vSelect>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.cutoff_date', { defaultValue: '截关日期' })" class="width-75per" prop="extra_cutoff_date" :rules="required">
                <vDatepicker type="date" v-model="formData.extra_cutoff_date"></vDatepicker>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.cutoff_order_date', { defaultValue: '截单日期' })" class="width-75per" prop="extra_cutoff_order_date">
                <vDatepicker type="date" v-model="formData.extra_cutoff_order_date"></vDatepicker>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.estimate_sail_at', { defaultValue: '预计开船日期' })" class="width-75per" prop="extra_expectsail_date" :rules="required">
                <vDatepicker type="date" v-model="formData.extra_expectsail_date"></vDatepicker>
            </vFormItem>
        </vForm>
        <!-- 已发船 -->
        <vForm class="clearfix" ref="dataForm" v-else-if="type === 'shipping'" v-model="formData" labelWidth="150" style="text-align: left;">
            <vFormItem prop="extra_logistics_no" class="width-75per" :label="`${$t('fbb.headlogistics.logistics_number_logistics', { defaultValue: '物流单号' })}/${$t('fbb.headlogistics.logistics_number', { defaultValue: '提单号' })}`" :rules="required">
                <vInput v-model="formData.extra_logistics_no"></vInput>
            </vFormItem>
            <!-- <vFormItem :label="$t('fbb.headlogistics.actual_loading_date', { defaultValue: '实际装柜日期' })" class="width-75per" prop="actual_loading_date" :rules="required">
                <vDatepicker v-model="formData.actual_loading_date" type="date" :confirm="false"></vDatepicker>
            </vFormItem> -->
            <vFormItem :label="$t('fbb.headlogistics.actual_sail_at', { defaultValue: '实际开船日期' })" class="width-75per" prop="extra_realsail_date" :rules="required">
                <vDatepicker type="date" v-model="formData.extra_realsail_date"></vDatepicker>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: '预计到港日期' })" class="width-75per" prop="extra_expectarrive_date" :rules="required">
                <vDatepicker type="date" v-model="formData.extra_expectarrive_date"></vDatepicker>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: '预计到仓日期' })" class="width-75per" prop="expect_stockin_at" :rules="required">
                <vDatepicker type="date" v-model="formData.expect_stockin_at"></vDatepicker>
            </vFormItem>
            <vFormItem :label="$t('fbb.headlogistics.sail_order_upload', { defaultValue: '提单上传' })" class="width-75per" prop="sail_order_src" :rules="required">
                <div class="upload" v-if="formData.sail_order_src">
                    <div class="upload-item">
                        <div class="filename">{{formData.sail_order_src}}</div>
                        <div><Icon class="close" size="13" type="md-close" @click="clearUpload" /></div>
                    </div>
                </div>
                <vButton v-else theme="success" @click="importFile">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
                <vInput class="hidden-input" hidden v-model="formData.sail_order_src"></vInput>
            </vFormItem>
        </vForm>
        <vModal
                class="hidefooter customerupload"
                v-model="operate.show"
                :title="operate.title"
                v-bind="operate"
            >
                <compUpload
                    v-bind="getFileProps"
                    @on-success="aaasuccess"
                    @on-cancel="cancelUpload"
                />
                <footer slot="footer" v-show="false"></footer>
            </vModal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
    HttpGetCompanyList,
    HttpGetSupplierById,
    HttpGetPaymentDetail
} from "@/service/headlogistics";
import mixinlist from '../mixin'
export default {
    mixins: [mixinlist],
    props: ["type", 'originData', 'logisticsType'],
    components: {
        compUpload: () => import("@components/templates/upload")
    },
    data() {
        return {
            purpose_port_item: {},
            companyList: [],
            formData: {},
            required: [
                {
                    required: true,
                    message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
                }
            ],
            operate: {
                show: false,
                title: this.$t('fbb.headlogistics.order_src', { defaultValue: "订舱单" }),
                data: {}
            }
        };
    },
    watch: {
        "formData.china_estimate_cost": {
            handler (val) {
                if (this.type != 'confirmBookingSpace') return;
                console.log(val)
                let price =
                    (val || 0) +
                    (this.formData.ocean_freight_estimate || 0)  +
                    (this.formData.destination_estimate_cost || 0)  +
                    (this.formData.tariff_estimate || 0) ;
                this.formData.price = price;
                console.log(this.formData.price);
            }
        },
        "formData.ocean_freight_estimate": {
            handler (val) {
                if (this.type != 'confirmBookingSpace') return;
                console.log(val)
                let price =
                    (val || 0)  +
                    (this.formData.china_estimate_cost || 0)  +
                    (this.formData.destination_estimate_cost || 0)  +
                    (this.formData.tariff_estimate || 0) ;
                this.formData.price = price;
                console.log(this.formData.price);
            }
        },
        "formData.destination_estimate_cost": {
            handler (val) {
                if (this.type != 'confirmBookingSpace') return;
                console.log(val)
                let price =
                    (val || 0)  +
                    (this.formData.china_estimate_cost || 0)  +
                    (this.formData.ocean_freight_estimate || 0)  +
                    (this.formData.tariff_estimate || 0) ;
                this.formData.price = price;
                console.log(this.formData.price);
            }
        },
        "formData.tariff_estimate": {
            handler (val) {
                if (this.type != 'confirmBookingSpace') return;
                console.log(val)
                let price =
                    (val || 0) +
                    (this.formData.china_estimate_cost || 0) +
                    (this.formData.ocean_freight_estimate || 0) +
                    (this.formData.destination_estimate_cost || 0);
                this.formData.price = price;
                console.log(this.formData);
                console.log(this.formData.price);
            }
        }
    },
    created () {
        if (this.type == 'confirmBookingSpace') {
            this.formData.price = 0;
            HttpGetCompanyList().then(res => {
                console.log(res);
                this.companyList = res.data.filter(item => {
                    return item.supplierType == 1;
                })
                .map(item => {
                    return {
                        value: item.code,
                        label: item.name,
                        attach: {
                            ...item
                        }
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        }
        this.formData = this.getDefaultParam
    },
    computed: {
        ...mapGetters('dictionary', ['getSystemPortList', 'getFilterDisabledWarehouse', 'getCompanyList']),
        getDefaultParam () {
            let param = {}
            switch (this.type) {
                // 确认订舱
                case 'confirmBookingSpace':
                    param = {
                        forwarder_warehouse_id: '',
                        // currency: 'USD',
                        // forwarder_warehouse_name: '',
                        // forwarder_warehouse_code: '',
                        order_src: '',
                        order_url: '',
                    }
                break
                // 已订舱
                case 'hasConfirmBookingSpace':
                // 已发船
                // case 'shipping':
                    param = {
                        extra_logistics_no: this.originData.preLogisticsNo
                    }
                break
            }
            return param
        },
        getFileProps() {
            return {
				action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
				name: "multipartFile",
				data: {
                    srcLabel: this.originData.id,
					model: 'logistics',
                    type: 'other',
				}
			}
        }
    },
    methods: {
        changePort () {
            let portItem = this.getSystemPortList.filter(item => {
                return item.value === this.formData.purpose_port_id
            })[0]
            this.formData.purpose_port = portItem.label
            this.formData.purpose_port_id = portItem.value
        },
        async changeForward () {
            console.log(this.companyList)
            let forwardItem = this.companyList.filter(item => {
                return item.value === this.formData.forwarder_id
            })[0];

            this.formData.forwarder_name = forwardItem.label
            let paymentTermId = 0;
            await HttpGetSupplierById({
                id: forwardItem.attach.id
            }).then(res => {
                paymentTermId = res.data.paymentTermId;
                this.$set(this.formData, 'agent_payment_id', res.data.paymentTermId);
            }, err => {
                this.$VMessage.error(err.message);
            });
            if (!paymentTermId) return;
            await HttpGetPaymentDetail({
                id: paymentTermId
            }).then(res => {
                console.log(res);
                // this.formData.agent_payment_term = res.data.paymentDescription;
                this.$set(this.formData, 'agent_payment_term', res.data.paymentDescription);
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        changeWareHouse () {
            let wareItem = this.getFilterDisabledWarehouse.filter(item => {
                return item.value === this.formData.forwarder_warehouse_id
            })[0]
            this.formData.forwarder_warehouse_name = wareItem.label
            this.formData.forwarder_warehouse_code = wareItem.attach.code
        },
        async checkForm () {
            let flag = true
            await this.$refs.dataForm.validate(valid => {
                if (!valid) {
                    flag = false
                }
            })
            return flag
        },
        importFile() {
            this.operate.show = true
            this.operate.title = this.$t('fbb.headlogistics.sail_order_upload', { defaultValue: '提单上传' })
        },
        aaasuccess(res) {
            switch (this.type) {
                // 确认订舱
                case 'confirmBookingSpace':
                    this.formData.order_src = res.data.entity.filename
                    this.formData.order_url = res.data.genUrl
                break
                // 已发船
                case 'shipping':
                    this.formData.sail_order_src = res.data.entity.filename
                    this.formData.sail_order_url = res.data.genUrl
                break
            }
            this.cancelUpload()
        },
        clearUpload () {
            switch (this.type) {
                // 确认订舱
                case 'confirmBookingSpace':
                    this.formData.order_src = ''
                    this.formData.order_url = ''
                break
                // 已发船
                case 'shipping':
                    this.formData.sail_order_src = ''
                    this.formData.sail_order_url = ''
                break
            }
            this.$forceUpdate()
        },
        cancelUpload() {
            this.operate.show = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.hidden-input {
    width: 56px;
    height: 30px;
    position: absolute;
    top: 333px;
    z-index: -1;
}
.upload-item {
    display: flex;
    color: #3399ff;

    .filename {
        width: 100%;
        overflow:hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
    }

    .close {
        margin-left: 5px;
        &:hover {
            color: red;
            cursor: pointer;
        }
    }
}
</style>
